import { createAPIModule } from 'utility/redux/apiModuleHelpers';
// import { createSelector } from 'reselect';

const getStateSlice = (state) => state.api.network.firewall.ruleset.update;

const {
	actions,
	reducer,
	sagas,
	selectors: defaultSelectors,
} = createAPIModule({
	getStateSlice,
	actionType: 'NETWORK_FIREWALL_RULESET_UPDATE',
	method: 'POST',
	url: '/network/firewall/ruleset/update.json',
});

const selectors = {
	...defaultSelectors,
};

export { actions, reducer, sagas, selectors };
